// eslint-disable-next-line no-restricted-imports
import { Switch as SwitchOriginal } from 'react-router';
import useLocation from '../react/hooks/useLocation';

type Props = {
    children: React.ReactNode;
};

export default function Switch({ children }: Props) {
    const location = useLocation();
    return <SwitchOriginal location={location}>{children}</SwitchOriginal>;
}
